import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Field } from 'formik'
import { CheckIcon, HeaderTwo, WarningIcon } from 'secondstep-components'

export const StyledCheckbox = styled.label`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 4px;
  cursor: pointer;
  background-color: ${props =>
    props.checked ? themeGet('colors.blue')(props) : 'white'};
  transition: background-color 0.2s ease;

  input:checked + & {
    background-color: ${themeGet('colors.blue')};
  }
`

export const CheckIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.2s ease;

  input:checked ~ ${StyledCheckbox} & {
    opacity: 1;
  }
`

export const ErrorText = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  margin-top: 0.6875rem;
  color: ${themeGet('colors.deleteRed')};
`

export const HiddenCheckbox = styled(Field)`
  display: none;
`

export const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1.75rem;

  input[type='radio'] {
    display: none;
  }
`

export const HeaderText = styled(HeaderTwo)`
  margin-top: 2rem;
  margin-bottom: 0.6875rem;
  font-size: 1.4375rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};

  ${themeGet('breakpoints.mobile')} {
    font-size: 1.438rem;
    margin-bottom: 0.375rem;
  }
`

export const Label = styled.label`
  margin-top: 0.125rem;
  margin-left: 0.4375rem;
  font-size: 1rem;
  color: ${themeGet('colors.darkGray')};
`

export const QuestionText = styled.span`
  font-size: 1rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
  margin-bottom: 0.375rem;
`

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  border-radius: 0.625rem;
  background-color: ${themeGet('colors.paleGray')};
`

export const RadioField = styled(Field)``

export const RadioCircle = styled.label`
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 50%;
  cursor: pointer;
  background-color: ${themeGet('colors.white')};

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: ${themeGet('colors.darkBlue')};
    transition: width 0.2s, height 0.2s;
  }

  ${RadioField}:checked + &::after {
    width: 12px;
    height: 12px;
  }
`

export const SelectionsWrapper = styled.div`
  display: flex;
  margin-top: 0.3125rem;
`

export const StyledCheckIcon = styled(CheckIcon)`
  width: 14px;
  height: 14px;
  color: ${themeGet('colors.white')};
`

export const StyledHr = styled.hr`
  width: 100%;
  height: 2px;
  border: none;
  background-color: ${themeGet('colors.white')};
`

export const StyledWarningIcon = styled(WarningIcon)`
  width: 14px;
  height: 14px;
  margin-right: 0.25rem;
  margin-bottom: 0.1875rem;
  color: ${themeGet('colors.deleteRed')};
`
